import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import transactionsServices from '@/api/transactionsServices';
import { RootState } from '@/app/store';
import { convertToUtc } from '@/utils/dateHelpers';

const initialState = {
  overview: [],
  expense: [],
  overvievLoading: false,
  expenseLoading: false,
  error: '',
  filters: '',
};

export const fetchFinancialOverview = createAsyncThunk('financialOverview/fetch', async ({ filters = {} }: { filters?: any }) => {
  const tmpFilters = {
    ...filters,
    startDate: convertToUtc(filters.startDate),
    endDate: convertToUtc(filters.endDate),
  };

  return transactionsServices.loadFinancialOverviewStatistic({ ...tmpFilters });
});

export const fetchExpenseBreakdown = createAsyncThunk('expenseBreakdown/fetch', async ({ filters = {} }: { filters?: any }) => {
  const tmpFilters = {
    ...filters,
    startDate: convertToUtc(filters.startDate),
    endDate: convertToUtc(filters.endDate),
  };

  return transactionsServices.loadExpenseBreakdownStatistic({ ...tmpFilters });
});

export const statisticSlice = createSlice({
  name: 'statistic',
  initialState,
  reducers: {
    saveFilters: (state, action: PayloadAction<string>) => {
      state.filters = action.payload;
    },
    refresh: () => initialState,
  },

  extraReducers: builder => {
    builder.addCase(fetchFinancialOverview.pending, state => {
      state.overvievLoading = true;
    });

    builder.addCase(fetchFinancialOverview.fulfilled, (state, action) => {
      const { payload: financialOverviewAttrs } = action;
      state.overview = financialOverviewAttrs.data;

      state.overvievLoading = false;
    });

    builder.addCase(fetchFinancialOverview.rejected, state => {
      state.overvievLoading = false;
      state.error = 'Error';
    });

    builder.addCase(fetchExpenseBreakdown.pending, state => {
      state.expenseLoading = true;
    });

    builder.addCase(fetchExpenseBreakdown.fulfilled, (state, action) => {
      const { payload: expenseBreakdownAttrs } = action;
      state.expense = expenseBreakdownAttrs.data;

      state.expenseLoading = false;
    });

    builder.addCase(fetchExpenseBreakdown.rejected, state => {
      state.expenseLoading = false;
      state.error = 'Error';
    });
  },
});

export const { refresh, saveFilters } = statisticSlice.actions;

export const selectStatistic = (state: RootState) => state.statistic;

export default statisticSlice.reducer;
